/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TableService {
  private _data: BehaviorSubject<any> = new BehaviorSubject(null);
  private _httpClient = inject(HttpClient);

  /**
   * Getter para acesso à propriedade privada "_data" como um observável
   */
  get data$(): Observable<any> {
    return this._data.asObservable();
  }

  getData(): Observable<any> {
    return this._httpClient.get('api/dashboards/project').pipe(
      tap((response: any) => {
        this._data.next(response);
      }),
    );
  }

  /**
   * A API pagina por `page`/`limit` (QueryBaseDto) e, com o whitelist do ValidationPipe,
   * recusa com 400 qualquer parâmetro desconhecido — `offset` (e `undefined` literal na
   * URL, como o table-tree enviava) derrubava a listagem inteira.
   */
  getDataApi(url: string, page?: number, limit?: number): Observable<any[]> {
    const params: string[] = [];
    if (limit) {
      params.push(`limit=${limit}`);
    }
    if (page) {
      params.push(`page=${page}`);
    }
    return this._httpClient.get<any[]>(params.length ? `${url}?${params.join('&')}` : url);
  }
}
